import React from 'react';
import { withCookies } from 'react-cookie';
import logout from '../../hooks/logout';

class Logout extends React.Component {
    constructor(props) {
        super(props);
        logout();
    }

    render() {
        return (
            <div id="logout">
                <div className="silverfort-loader">
                    <div className="logo"></div>
                </div>
            </div>
        );
    }
}

export default withCookies(Logout);
